var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"datepickerWrap",staticClass:"date-picker__inner w-full bg-white z-50",class:{
    'animate-fade-in-down': _vm.isOpen,
    'relative opacity-100': _vm.isInline,
    'absolute top-full left-0 pt-4 opacity-0': !_vm.isInline
  },attrs:{"aria-hidden":"true"}},[_c('div',{ref:"datepicker",staticClass:"date-picker__elm-wrapper  relative"})])}
var staticRenderFns = []

export { render, staticRenderFns }